supertypeMap